export const CLIENT_PO_CSV_HEADERS = [
  'ID',
  'Client Code',
  'Client Name',
  'PO Number',
  'Service Area',
  'PO Date',
  'Start Date',
  'End Date',
  'Amount',
  'Portfolio',
  'Sales Person',
  'Duration',
  'Description',
  'Status',
  'Created At',
  'Updated At',
] as const

export function formatPurchaseOrderStatusForExport(
  isActive: boolean | null | undefined
): string {
  return isActive ? 'Active' : 'Expired'
}

export function formatPoNumberForExport(poNumber: string | null | undefined): string {
  const value = String(poNumber ?? '').trim()
  if (!value) return ''
  // Excel formula-as-text keeps full digit strings (avoids 1.029E+11).
  return `="${value}"`
}

function formatDateForExport(value: unknown): string {
  const raw = String(value ?? '').trim().slice(0, 10)
  if (!raw) return ''
  return `\t${raw}`
}

export function mapPurchaseOrderToCsvRow(po: Record<string, unknown>): string[] {
  const client = po.client as { code?: string; name?: string } | undefined

  return [
    po.id != null ? String(po.id) : '',
    client?.code ?? '',
    client?.name ?? '',
    formatPoNumberForExport(String(po.po_number ?? '')),
    String(po.domain ?? ''),
    formatDateForExport(po.po_date),
    formatDateForExport(po.start_date),
    formatDateForExport(po.end_date),
    po.amount != null && po.amount !== '' ? String(po.amount) : '',
    String(po.portfolio ?? ''),
    String(po.sales_person ?? ''),
    String(po.duration ?? ''),
    String(po.description ?? ''),
    formatPurchaseOrderStatusForExport(po.is_active as boolean | undefined),
    String(po.created_at ?? ''),
    String(po.updated_at ?? ''),
  ]
}

export const CLIENT_PO_CSV_TEMPLATE_EXAMPLE_ROW: string[] = [
  '',
  'ACME',
  'Acme Corporation',
  'CPO-2026-001',
  'IT Infrastructure',
  '2026-01-01',
  '2026-01-01',
  '2026-12-31',
  '100000.00',
  'IT Resource Outsourcing',
  'Jane Doe',
  '12 months',
  'Sample purchase order',
  '',
  '',
  '',
]
